var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaseReviews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 197,
    viewBox: "0 0 223 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0996094 0H222.1V197H0.0996094V0Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 183.101H99.2998L106.4 10.2012H115.8L123 183.101Z",
    fill: "#FF8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1 13.5V183.1H123L116 13.5H111.1Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1 5.20117H180.9V13.2012L111.1 21.8012V5.20117Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9 13.2012V10.7012H119V20.8012L180.9 13.2012Z",
    fill: "#FF8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.099 21.8012L41.3994 13.2012V5.20117H111.099V21.8012Z",
    fill: "#FF991F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7998 13.2012L103.8 20.9012V10.7012H41.7998V13.2012Z",
    fill: "#FF8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 27.8C118.676 27.8 124.9 21.5768 124.9 13.9C124.9 6.22324 118.676 0 111 0C103.323 0 97.0996 6.22324 97.0996 13.9C97.0996 21.5768 103.323 27.8 111 27.8Z",
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 191.201V191.401H130.1C125.061 188.8 120.416 185.501 116.3 181.601C114.106 179.484 112.067 177.211 110.2 174.801C89.6704 174.879 69.55 180.549 52 191.201Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.9 0.900303C114.338 0.29434 112.675 -0.0110156 111 0.000303533C107.313 0.000303533 103.778 1.46476 101.171 4.07152C98.5641 6.67828 97.0996 10.2138 97.0996 13.9003C97.0996 17.5868 98.5641 21.1223 101.171 23.7291C103.778 26.3358 107.313 27.8003 111 27.8003H111.3C109.273 20.9531 109.626 13.6215 112.3 7.0003C113.237 4.82278 114.446 2.77305 115.9 0.900303Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.678 25.4627L139.322 128.438L141.184 129.167L181.54 26.1925L179.678 25.4627Z",
    fill: "#FFE380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.77 25.2234L179.908 25.9531L220.278 128.965L222.14 128.235L181.77 25.2234Z",
    fill: "#FFE380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7537 25.3406L40.8916 26.0703L81.2616 129.082L83.1237 128.353L42.7537 25.3406Z",
    fill: "#FF991F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5595 25.3787L0.204102 128.354L2.06621 129.083L42.4216 26.1085L40.5595 25.3787Z",
    fill: "#FF991F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7995 130.202C45.2995 119.002 57.8995 109.002 71.7995 99.2021C74.6082 97.339 76.9647 94.8713 78.6963 91.9796C80.4279 89.088 81.4908 85.8457 81.8072 82.4901C82.1236 79.1345 81.6854 75.7506 80.5248 72.5863C79.3642 69.422 77.5105 66.5573 75.0995 64.2021C73.4874 62.4914 71.5931 61.0707 69.4995 60.0021C63.0995 56.9021 56.4995 58.8021 55.1995 59.2021C45.9995 62.0021 42.3995 70.5021 41.7995 71.7021C41.2995 70.5021 37.5995 62.0021 28.3995 59.2021C27.1995 58.8021 20.4995 56.9021 14.0995 60.0021C12.0234 61.0985 10.1334 62.516 8.49948 64.2021C6.12225 66.5749 4.29865 69.4437 3.15905 72.6033C2.01946 75.7628 1.59203 79.1352 1.90732 82.4792C2.22261 85.8232 3.27283 89.0562 4.9829 91.9471C6.69297 94.838 9.02064 97.3154 11.7995 99.2021C25.7995 109.002 38.2995 119.002 41.7995 130.202Z",
    fill: "#0052CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3996 25.8012C47.0881 25.8012 51.6996 21.1897 51.6996 15.5012C51.6996 9.81264 47.0881 5.20117 41.3996 5.20117C35.7111 5.20117 31.0996 9.81264 31.0996 15.5012C31.0996 21.1897 35.7111 25.8012 41.3996 25.8012Z",
    fill: "#FF991F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9 25.8012C186.588 25.8012 191.2 21.1897 191.2 15.5012C191.2 9.81264 186.588 5.20117 180.9 5.20117C175.211 5.20117 170.6 9.81264 170.6 15.5012C170.6 21.1897 175.211 25.8012 180.9 25.8012Z",
    fill: "#FFE380"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M11.7999 99.2004C25.7999 109 38.2999 119 41.7999 130.2C44.1999 122.6 50.6999 115.6 58.9999 108.8C54.5063 104.976 49.446 101.872 43.9999 99.6004C37.1999 96.9004 33.0999 96.9004 28.7999 95.8004C20.9999 93.7004 12.0999 87.8004 2.89991 73.4004C2.48151 74.4926 2.21241 75.6362 2.09991 76.8004C1.42752 81.0696 1.98235 85.4419 3.69974 89.4078C5.41712 93.3737 8.22632 96.7699 11.7999 99.2004Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9 130.202C184.3 119.002 196.9 109.002 210.8 99.2021C213.586 97.3234 215.922 94.8523 217.641 91.9655C219.361 89.0786 220.421 85.8474 220.746 82.5031C221.071 79.1587 220.652 75.7839 219.521 72.6201C218.389 69.4563 216.572 66.5817 214.2 64.2021C212.524 62.5211 210.602 61.1048 208.5 60.0021C202.2 56.9021 195.5 58.8021 194.3 59.2021C185.1 62.0021 181.4 70.5021 180.9 71.7021C180.3 70.5021 176.6 62.0021 167.4 59.2021C166.2 58.8021 159.5 56.9021 153.2 60.0021C151.106 61.0707 149.212 62.4914 147.6 64.2021C144.12 67.5831 141.838 72.0068 141.1 76.8021C140.426 81.0817 140.99 85.465 142.726 89.4342C144.463 93.4034 147.299 96.7928 150.9 99.2021C164.8 109.002 177.4 119.002 180.9 130.202Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M150.9 99.2004C164.8 109 177.4 119 180.9 130.2C183.2 122.6 189.7 115.6 198 108.8C193.527 104.999 188.503 101.897 183.1 99.6004C176.3 96.9004 172.1 96.9004 167.8 95.8004C160 93.7004 151.1 87.8004 141.9 73.4004C141.528 74.5063 141.26 75.6446 141.1 76.8004C140.426 81.08 140.99 85.4633 142.726 89.4325C144.463 93.4018 147.299 96.7911 150.9 99.2004Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0998 127.602H0.699841C0.561468 127.616 0.430491 127.671 0.323625 127.76C0.216759 127.849 0.13885 127.968 0.0998408 128.102C-0.000159182 128.402 0.199841 128.602 0.399841 128.802C12.7706 136.325 26.971 140.304 41.4498 140.304C55.9287 140.304 70.1291 136.325 82.4998 128.802C82.598 128.714 82.6757 128.606 82.7275 128.485C82.7794 128.364 82.804 128.233 82.7998 128.102C82.7429 127.96 82.6468 127.838 82.5228 127.749C82.3988 127.661 82.252 127.61 82.0998 127.602Z",
    fill: "#FF991F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.2 127.602H139.8C139.648 127.61 139.501 127.661 139.377 127.75C139.253 127.838 139.157 127.96 139.1 128.102C139.096 128.233 139.121 128.364 139.172 128.485C139.224 128.606 139.302 128.714 139.4 128.802C151.771 136.325 165.971 140.304 180.45 140.304C194.929 140.304 209.129 136.325 221.5 128.802C221.7 128.602 221.9 128.402 221.8 128.102C221.776 127.96 221.703 127.832 221.593 127.741C221.483 127.649 221.343 127.6 221.2 127.602Z",
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9 21.9016C179.634 21.9016 178.397 21.5262 177.344 20.823C176.292 20.1197 175.472 19.1202 174.987 17.9507C174.503 16.7813 174.376 15.4945 174.623 14.253C174.87 13.0115 175.479 11.8711 176.375 10.9761C177.27 10.081 178.41 9.47148 179.651 9.22454C180.893 8.97759 182.18 9.10434 183.349 9.58874C184.519 10.0731 185.518 10.8934 186.221 11.9459C186.925 12.9984 187.3 14.2358 187.3 15.5016C187.3 16.342 187.134 17.1743 186.813 17.9507C186.491 18.7272 186.02 19.4328 185.425 20.0271C184.831 20.6213 184.126 21.0928 183.349 21.4144C182.573 21.736 181.74 21.9016 180.9 21.9016ZM180.9 11.1016C179.724 11.1013 178.594 11.5616 177.753 12.384C176.912 13.2064 176.426 14.3255 176.4 15.5016C176.38 16.3956 176.627 17.2752 177.109 18.0283C177.592 18.7813 178.287 19.3737 179.108 19.7296C179.928 20.0856 180.836 20.1891 181.715 20.0269C182.594 19.8648 183.406 19.4443 184.045 18.8191C184.684 18.1939 185.123 17.3924 185.305 16.5169C185.487 15.6414 185.404 14.7315 185.066 13.9034C184.729 13.0753 184.152 12.3665 183.41 11.8675C182.668 11.3684 181.794 11.1018 180.9 11.1016Z",
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4 21.9016C39.7026 21.9016 38.0747 21.2273 36.8745 20.027C35.6743 18.8268 35 17.1989 35 15.5016C35 13.8042 35.6743 12.1763 36.8745 10.9761C38.0747 9.77585 39.7026 9.10156 41.4 9.10156C43.0974 9.10156 44.7253 9.77585 45.9255 10.9761C47.1257 12.1763 47.8 13.8042 47.8 15.5016C47.8 17.1989 47.1257 18.8268 45.9255 20.027C44.7253 21.2273 43.0974 21.9016 41.4 21.9016ZM41.4 11.1016C40.233 11.1016 39.1139 11.5651 38.2887 12.3903C37.4636 13.2155 37 14.3346 37 15.5016C37 16.0794 37.1138 16.6515 37.3349 17.1854C37.5561 17.7192 37.8801 18.2043 38.2887 18.6128C39.1139 19.438 40.233 19.9016 41.4 19.9016C41.9816 19.9153 42.5598 19.8108 43.0999 19.5945C43.6399 19.3782 44.1304 19.0547 44.5417 18.6433C44.9531 18.232 45.2767 17.7415 45.493 17.2014C45.7092 16.6614 45.8137 16.0831 45.8 15.5016C45.8 14.3346 45.3364 13.2155 44.5113 12.3903C43.6861 11.5651 42.567 11.1016 41.4 11.1016Z",
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 23.4004C109.121 23.4004 107.284 22.8432 105.722 21.7994C104.16 20.7555 102.942 19.2718 102.223 17.5359C101.504 15.8 101.316 13.8899 101.683 12.047C102.049 10.2042 102.954 8.51148 104.282 7.18288C105.611 5.85428 107.304 4.94949 109.147 4.58293C110.989 4.21638 112.9 4.40451 114.635 5.12354C116.371 5.84257 117.855 7.06021 118.899 8.62248C119.943 10.1847 120.5 12.0215 120.5 13.9004C120.474 16.4119 119.465 18.8132 117.689 20.5891C115.913 22.3651 113.511 23.3744 111 23.4004ZM111 6.40039C109.517 6.40039 108.067 6.84026 106.833 7.66437C105.6 8.48848 104.639 9.65982 104.071 11.0303C103.503 12.4007 103.355 13.9087 103.644 15.3636C103.934 16.8184 104.648 18.1548 105.697 19.2037C106.746 20.2526 108.082 20.9669 109.537 21.2563C110.992 21.5457 112.5 21.3971 113.87 20.8295C115.241 20.2618 116.412 19.3005 117.236 18.0672C118.06 16.8338 118.5 15.3838 118.5 13.9004C118.474 11.9193 117.676 10.0267 116.275 8.62573C114.874 7.22479 112.981 6.42629 111 6.40039Z",
    fill: "#FFE380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 174.699C131.931 174.672 152.459 180.453 170.3 191.399H51.5996C69.4712 180.44 90.0352 174.658 111 174.699Z",
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 191.201V191.401H130.1C125.061 188.8 120.416 185.501 116.3 181.601C114.106 179.484 112.067 177.211 110.2 174.801C89.6704 174.879 69.55 180.549 52 191.201Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5994 191.301H169.199C170.711 191.301 172.161 191.901 173.23 192.97C174.299 194.039 174.899 195.489 174.899 197.001H45.8994C45.8994 195.489 46.4999 194.039 47.5689 192.97C48.6379 191.901 50.0877 191.301 51.5994 191.301Z",
    fill: "#FF991F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 117.06,
    y1: 183.08,
    x2: 117.06,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF0B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 111.13,
    y1: 13.5012,
    x2: 180.86,
    y2: 13.5012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE380"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 52,
    y1: 183.091,
    x2: 166.04,
    y2: 183.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF991F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FFC400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 93.4088,
    y1: 11.7813,
    x2: 133.419,
    y2: 11.7926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF991F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FFC400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: -20.9801,
    y1: 101.8,
    x2: 83.2599,
    y2: 101.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#091E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091E42",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 140.79,
    y1: 94.2621,
    x2: 220.92,
    y2: 94.2621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#0065FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C9AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 6884.82,
    y1: 5855.64,
    x2: 12844.9,
    y2: 5855.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#091E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091E42",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 52,
    y1: 183.091,
    x2: 166.04,
    y2: 183.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF991F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FFC400"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0996094 0H222.1V197H0.0996094V0Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseReviews);
export default __webpack_public_path__ + "static/media/case-reviews.cf463bde2b2327751f1444c9be13425f.svg";
export { ForwardRef as ReactComponent };